<da-single-stage [data]="'error.singleStage' | translate"></da-single-stage>
<section class="background-color-nearwhite" *ngIf="('error.teaserBox' | translate) !== 'error.teaserBox'">
    <da-teaser-boxes-container [data]="'error.teaserBox' | translate"></da-teaser-boxes-container>
</section>
